module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Right Chaise_Ocean.761243e7.png";